import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";

const API = (process.env.REACT_APP_BACKEND_URL || "") + "/api";
const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  // user: undefined = checking, null = anonymous, object = logged in
  const [user, setUser] = useState(undefined);

  const _authHeader = () => {
    const t = localStorage.getItem("ms_token");
    return t ? { Authorization: `Bearer ${t}` } : {};
  };

  const refresh = useCallback(async () => {
    const t = localStorage.getItem("ms_token");
    if (!t) { setUser(null); return; }
    try {
      const { data } = await axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${t}` } });
      setUser(data);
    } catch {
      localStorage.removeItem("ms_token");
      setUser(null);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password });
    localStorage.setItem("ms_token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await axios.post(`${API}/auth/register`, payload);
    return data;
  };

  const logout = () => {
    localStorage.removeItem("ms_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, register, logout, refresh, authHeader: _authHeader }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

export const formatApiError = (detail) => {
  if (!detail) return "Unbekannter Fehler";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
};
